import axios from "axios";
import { API_END_POINT } from "../../constants/api";

import { returnErrors, clearErrors } from "./errorAction";
export const ADD_CLOTH_RETURN = "ADD_CLOTH_RETURN";
export const ADD_CLOTH_RETURN_SUCCESS = "ADD_CLOTH_RETURN_SUCCESS";
export const ADD_CLOTH_RETURN_FAIL = "ADD_CLOTH_RETURN_FAIL";
export const CLOTH_RETURN_HISTORY = "CLOTH_RETURN_HISTORY";

export function addClothReturn(clothReturn) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const values = {
      ...clothReturn,
      date_dispatch: clothReturn.date_cloth_return.format("YYYY-MM-DD"),
    };
    const body = JSON.stringify(values);

    axios
      .post(`${API_END_POINT}/api/Contract/ClothReturn/Register`, body, config)
      .then((res) =>
        dispatch({
          type: ADD_CLOTH_RETURN,
          payload: res.data,
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "cloth return  add Successfully",
            201,
            "ADD_CLOTH_RETURN_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "ADD_CLOTH_RETURN_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
export function clothReturnHistory(params) {
  return (dispatch) => {
    const token = localStorage.getItem("usertoken");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const body = JSON.stringify(params);

    axios
      .post(`${API_END_POINT}/api/company/cloth-return/list`, body, config)
      .then((res) =>
        dispatch({
          type: CLOTH_RETURN_HISTORY,
          payload: res.data,
        })
      )

      .catch((err) => console.log("err", err));
  };
}
